import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"width":"100%"} }
const _hoisted_2 = { class: "text-big" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-warning" }, "Note:"),
  /*#__PURE__*/_createTextVNode(" They will also be removed from any "),
  /*#__PURE__*/_createElementVNode("b", null, "Teams"),
  /*#__PURE__*/_createTextVNode(" and "),
  /*#__PURE__*/_createElementVNode("b", null, "Groups"),
  /*#__PURE__*/_createTextVNode(" in this organisation. ")
], -1)

import { ref } from "vue";
import axios from "axios";
import { Modal } from "uiv";

import { OrganisationAndMembersApiModel, OrganisationMemberApiModel } from "../../../api-models";


export default /*#__PURE__*/_defineComponent({
  __name: 'organisation-member-removal-dialog',
  setup(__props, { expose: __expose }) {

const resolveCallback = ref<((value: boolean) => void) | null>(null);
const rejectCallback = ref<((reason?: any) => void) | null>(null);

const errors = ref<string[]>([]);
const member = ref<OrganisationMemberApiModel | null>(null);
const organisationAndMembers = ref<OrganisationAndMembersApiModel | null>(null);
const shown = ref(false);
// @Component({ components: { Modal } })
// export default class OrganisationMemberRemovalDialog extends Vue {
//   resolveCallback: ((value: boolean) => void) | null = null;

//   rejectCallback: ((reason?: any) => void) | null = null;

//   errors: string[] = [];

//   member: OrganisationMemberApiModel | null = null;

//   organisationAndMembers: OrganisationAndMembersApiModel | null = null;

//   shown = false;

function close(): void {
  shown.value = false;
}

function cancel(): void {
  close();
  if (resolveCallback.value) {
    resolveCallback.value(false);
  }
}

function open(
  memberModel: OrganisationMemberApiModel,
  organisationAndMembersModel: OrganisationAndMembersApiModel,
): Promise<boolean> {
  member.value = memberModel;
  organisationAndMembers.value = organisationAndMembersModel;
  errors.value = [];
  shown.value = true;
  return new Promise((resolve, reject) => {
    resolveCallback.value = resolve;
    rejectCallback.value = reject;
  });
}

function doDelete(): void {
  axios
    .delete(`/api/organisationmember/${member.value?.shortUserDetails.id}`)
    .then((res) => {
      if (res.status !== 200) {
        errors.value = ["There was a problem removing the user, please try again."];
      } else {
        errors.value = [];
        close();
        if (resolveCallback.value) {
          resolveCallback.value(true);
        }
      }
    })
    .catch((error) => {
      errors.value = ["There was a problem removing the user, please try again."];
      if (error?.response?.data?.length) {
        errors.value.push(error.response.data);
      }
    });
}

__expose({ open, close });

return (_ctx: any,_cache: any) => {
  return (member.value && organisationAndMembers.value)
    ? (_openBlock(), _createBlock(_unref(Modal), {
        key: 0,
        class: "organisation-member-removal-dialog text-left",
        modelValue: shown.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((shown).value = $event)),
        title: 
      'Remove ' + member.value.shortUserDetails.firstName + ' ' + member.value.shortUserDetails.lastName + '?'
    
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              class: "btn btn-primary btn-lg",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (doDelete())),
              type: "button"
            }, "Remove"),
            _createElementVNode("button", {
              class: "btn btn-default btn-lg",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (cancel())),
              type: "button"
            }, "Cancel")
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("p", _hoisted_2, [
              _createTextVNode(" Are you sure you want to remove "),
              _createElementVNode("b", null, _toDisplayString(member.value.shortUserDetails.firstName) + " " + _toDisplayString(member.value.shortUserDetails.lastName), 1),
              _createTextVNode(" from "),
              _createElementVNode("b", null, _toDisplayString(organisationAndMembers.value.name), 1),
              _createTextVNode("? ")
            ]),
            _hoisted_3,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errors.value, (error) => {
              return (_openBlock(), _createElementBlock("p", {
                class: "text-danger text-left",
                key: error
              }, _toDisplayString(error), 1))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "title"]))
    : _createCommentVNode("", true)
}
}

})